import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import MetaTags from 'react-meta-tags'
import AddToCalendar from 'react-add-to-calendar';
import AOS from 'aos';
import 'aos/dist/aos.css'; 

import * as actions from "../actions";

AOS.init({
  duration: 800
});

class RSVPThankYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attend: "",
      guest: "",
      event: {
        title: 'Tuck & Rose: Wedding Lunch @ Swissotel Merchant Court Ballroom',
        description: 'You are invited to Tuck & Rose\'s wedding lunch at 12PM! Solemnization begins at 11AM.',
        location: '20 Merchant Rd Singapore 058281',
        startTime: '2018-12-23T11:00+08:00',
        endTime: '2018-12-23T16:00+08:00'
      }
    }
  }

  getParams() {

    var params = {},
        pairs = this.props.location.search.split('?')
               .pop()
               .split('&');
    for (var i = 0, p; i < pairs.length; i++) {
           p = pairs[i].split('=');
           params[ p[0] ] =  decodeURIComponent(p[1]);
    }     

    return params;
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.images.mcFetchStatus === "success") { 
        this.setState({ guest: nextProps.images.mcdata[0].GUESTNAME })
        this.setState({ attend: nextProps.images.mcdata[0].ATTEND })
    }

  }

  componentWillMount() {
    window.scrollTo(0, 0)
    var params = this.getParams();
    if(params.rand) {
      var rand = params.rand;
      this.props.fetchMailchimpMember(rand);
    }
  }

  render() {
    return (
      <div className="main-wrapper homepage">

        <MetaTags>
          <title>Tuck and Rose: Thank You!</title>
          <meta name="description" content="Thank you for letting us know your availability! We'll be in touch." />
          <meta name="og:title" content="Tuck and Rose: Thank You!" />
          <meta name="og:site_name" content="Tuck and Rose" />
          <meta name="og:url" content="https://tuckandrose.family/thank-you" />
          <meta name="og:type" content="website" />
          <meta name="og:description" content="Thank you for letting us know your availability! We'll be in touch." />
          <meta name="og:image" content="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/social.jpg" />
          <meta name="og:locale" content="en_SG" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Tuck and Rose: Thank You!" />
          <meta name="twitter:url" content="https://tuckandrose.family/thank-you" />
          <meta name="twitter:description" content="Thank you for letting us know your availability! We'll be in touch." />
          <meta name="twitter:image:src" content="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/social.jpg" />
          <link rel="canonical" href="https://tuckandrose.family/thank-you" />
          <link rel="alternate" hreflang="x-default" href="https://tuckandrose.family/thank-you" />
        </MetaTags>

        <div className="main-wrapper-inner"> 
          <section className="main-content">
            <div className={"master-header white-bg vh-100 valign-wrapper " + (this.state.attend == 'Joyfully accept' ? 'accept' : 'declined')}>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flowers.png" alt="Flowers header" className="flower-header w-100" data-aos="zoom-out"/>
              <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/mobile/flowers.png" alt="Flowers header" className="m-flower-header w-100 hide" data-aos="zoom-out"/>
                <div className="letter-container md bottom">
                  <div className="inner-content md center-align">
                    <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/small-tr.png" alt="Tuck and Rose" className="small-tr mb" data-aos="zoom-in"  data-aos-delay="500"/>
                    <p className="mt-5 mb-5">Dear {this.state.guest},</p>
                    {this.state.attend == "Joyfully accept" ? (
                      <div>
                        <p>Thank you for making the time in this holiday season to join us for&nbsp;our&nbsp;wedding!</p>
                        <p>We're really excited to share our big&nbsp;day&nbsp;with&nbsp;you.</p>
                        <p>If you're driving, be sure to obtain a carpark coupon from reception on&nbsp;the&nbsp;day.</p>
                        <p>Don't forget to save the date on&nbsp;your&nbsp;calendar!</p>

                        <AddToCalendar event={this.state.event} buttonLabel="Add to Calendar"/>

                        <p>We look forward to seeing you there!</p>
                        <p className="mt-fluid">Tuck & Rose</p>
                       </div>
                    ) : (
                      <div>
                        <p>We're sorry to hear that you won't be able to make it to&nbsp;our&nbsp;wedding.</p>
                        <p>Thank you very much for letting&nbsp;us&nbsp;know.</p>
                        <p>But don't be a stranger, should you change your mind, please reach&nbsp;out&nbsp;to&nbsp;us.</p>
                        <p>Have a blessed holiday season, and a happy&nbsp;2019&nbsp;ahead!</p>
                        <p className="mt-fluid">Tuck & Rose</p>
                       </div>
                    )}
                    <div className="flower-3" data-aos="zoom-in" data-aos-delay="1000"></div>
                    <div className="leaf-1" data-aos="zoom-in" data-aos-delay="1300"></div>
                    <div className="flower-6" data-aos="zoom-in" data-aos-delay="200"></div>
                  </div>
                  <div className="flower-1" data-aos="zoom-in" data-aos-delay="200"></div>
                  <div className="flower-2" data-aos="zoom-in" data-aos-delay="200"></div>
                </div>
              </div>
          </section>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    images: state.images
  };
}

export default connect(mapStateToProps, actions)(RSVPThankYou);



// WEBPACK FOOTER //
// ./src/containers/RSVPThankYou.js